import $ from 'jquery';

export const addToBagWithData = (data, callback) => {
    if (!data) {
        return;
    }

    const rcProps = window.rcProps || {};
    if (!data.sectionURL) {
        data.sectionURL = rcProps.sectionUrl;
    }
    if (!data.csrfHash) {
        data.csrfHash = rcProps.csrfHash;
    }
    if (!data.d) {
        data.d = rcProps.department;
    }
    if (!data.contextReferrer) {
        data.contextReferrer = document.referrer;
    }

    data.successCallback = callback;

    addProductWithData(data);

    const pdpData = rcProps.pdp || {};

    if (!$.isEmptyObject(pdpData)) {
        const googleRemarketing = rcProps.googleRemarketing || {};
        const fitPredictor = rcProps.fitPredictor || {};

        if (typeof insertFacebookAddToCart === 'function') {
            insertFacebookAddToCart(null, data.productCode, pdpData.retailPrice, data.size);
        }

        if (typeof addToCartReddit === 'function') {
            var cartItems = new Array();
            {
                var cartItem = {};
                cartItem.productCode = data.productCode;
                cartItem.productName = pdpData.productName;
                cartItem.productCategory = pdpData.categoryName;

                cartItems.push(cartItem);
            }
            addToCartReddit(cartItems, pdpData.retailPrice, data.productCode, pdpData.productName, pdpData.categoryName);
        }

        if (typeof spanglePixelAddToCart === 'function') {
            spanglePixelAddToCart(data.productCode, pdpData.retailPrice, 1);
        }

        if (googleRemarketing.isAllowed) {
            try{
                // Google Remarketing Script add to bag start
                $.getScript("//www.googleadservices.com/pagead/conversion_async.js", function(){
                    if (typeof window.google_trackConversion === 'function') {
                        window.google_trackConversion({
                            google_conversion_id: googleRemarketing.conversionId,
                            google_custom_params: {
                                ecomm_pagetype: 'cart',
                                prodid: googleRemarketing.cartString,
                                ecomm_totalvalue: $('#addtobagbutton').data('totalCart'),
                                google_crm_id: googleRemarketing.crmId,
                                purchaser: googleRemarketing.purchaser,
                                orders: googleRemarketing.orderTotal
                            },
                            google_conversion_label: 'bP-DCMus-AIQ-fuh_wM',
                            google_remarketing_only: true
                        });
                    }
                });
                // Google Remarketing Script add to bag end
            } catch (googleRemarketingBagException){
                console.log('Google remarketing bag exception' + googleRemarketingBagException);
            }
        }

        if (fitPredictor.show) {
            // fit predictor
            ssp('track', 'addVariantToCart', {
                variantId: pdpData.code,
                productId: fitPredictor.code,
                quantity: 1
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/modules/add-to-bag.js